export default "/images/1402711b2fe5396f33fe62af92866a0e.avif";